import noConsultationsIcon from "assets/images/pregnancy/empty-pregnancy-consultations.svg";
import { Button } from "components/ui/Button";

import style from "./PregnancyNoPostNatalConsultationsFound.module.css";

export const PregnancyNoPostNatalConsultationsFound = ({
  onStartConsultationButtonClick,
}) => {
  return (
    <section className={style.emptyState}>
      <img className={style.element} alt="Element" src={noConsultationsIcon} />
      <div className={style.text}>
        <div className={style.div}>
          <div className={style.textWrapper}>
            No post-natal consultations yet
          </div>
          <p>
            Add the first postnatal consultation to begin monitoring the health
            of both the mother and baby.
          </p>
        </div>
        <Button variant="primary" onClick={onStartConsultationButtonClick}>
          Start first consultation
        </Button>
      </div>
    </section>
  );
};
